import classes from "./ColorStatus.module.scss";

const ColorStatus = ({ text, status }) => {
  return (
    <div className={classes.ColorStatus}>
      <div className={[classes.Color, classes[status]].join(" ")}></div>
      <span className={classes.Text}>{text}</span>
    </div>
  );
};

export default ColorStatus;
